import {computed} from 'mobx';
import {BaseModel} from "../../../../infrastructure/models/base-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import type {DeviceViewModel} from "../../../../core/models/device.view-model";
import {NavigationTabsModuleTabModel} from "../tabs/navigation-tabs-module.tab-model";
import type {AppTerms} from "../../../../core/app/app-terms";

export class NavigationTabsModuleEntityViewModel extends BaseModel {
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;
  terms: AppTerms;
  device: DeviceViewModel;

  constructor(entity: EntityViewModel, currentLinkModel: BaseLinkModel, terms: AppTerms, isWidget: boolean) {
    super();

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
    this.terms = terms;
    this.isWidget = isWidget;
  }

  @computed get tabs(): Array<NavigationTabsModuleTabModel> {
    return console.error(this.constructor.name + 'Implementation is missing: tabs');
  }

  @computed get activeTab(): NavigationTabsModuleTabModel {
    return this.tabs?.find(tab => tab.isActive);
  }

  @computed get isFirstTabIndex(): Number {
   return this.tabs?.first()?.index === this.activeTab?.index;
  }

  @computed get isLastTabIndex(): Number {
    return this.tabs?.last()?.index === this.activeTab?.index;
  }

  @computed get customTabs(): Array<NavigationTabsModuleTabModel> {
    return [];
  }

  get useRouteProps(): Boolean {
    return false;
  }
}
